import { render, staticRenderFns } from "./PlpEditorialBlock.vue?vue&type=template&id=0235f9fa&scoped=true&"
import script from "./PlpEditorialBlock.vue?vue&type=script&lang=js&"
export * from "./PlpEditorialBlock.vue?vue&type=script&lang=js&"
import style0 from "./PlpEditorialBlock.vue?vue&type=style&index=0&id=0235f9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235f9fa",
  null
  
)

export default component.exports